import { useState } from 'react';

const CustomSnackbar = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarClass, setSnackbarClass] = useState('');

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, className) => {
    setSnackbarMessage(message);
    setSnackbarClass(className);
    setSnackbarOpen(true);
  };

  return {
    showSnackbar,
    snackbarOpen,
    handleCloseSnackbar,
    snackbarMessage,
    snackbarClass
  };
};

export default CustomSnackbar;